<template>
  <div>
    <!-- <Navgar></Navgar> -->
    <div class="services">
      <div class="content">
        <div class="card card-box1">
          <h2>有职 A+ 计划</h2>
          <ul>
            <li>2v1陪伴式学习，因材施教更高效</li>
            <li>10年经验大厂导师，亲自授课</li>
            <li>3个月以上的服务周期</li>
            <li>国央企、银行、互联网、金融等无所不能</li>
            <li>真正的总部，从招聘基础知识讲起</li>
            <li>发掘每个学生独特的优点</li>
            <li>“手把手”的简历诊断与打磨</li>
            <li>全程为您保驾护航的求职私教</li>
            <li>笔试面试全人模模拟辅导</li>
            <li>优秀导师的职业方案</li>
            <li>氛围良好的求职交流专属社群</li>
          </ul>
          <button @click="goContact">了解详情</button>
        </div>
        <div class="card card-box2">
          <h2>有职独家线上实习</h2>
          <ul>
            <li>实操参与国内知名大厂项目</li>
            <li>定制化的职业规划解析</li>
            <li>覆盖30+大学生实习岗位</li>
            <li>为期1-3个月的实习时间</li>
            <li>提供实习证明与推荐信</li>
            <li>根据实习经历优化个人简历</li>
            <li>高标准的支付导师</li>
            <!-- <li style="list-style: none"></li>
            <li style="list-style: none"></li>
            <li style="list-style: none"></li>
            <li style="list-style: none"></li> -->
          </ul>
          <button @click="goContact">了解详情</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navgar from "../components/Navgar/Navgar.vue";
export default {
  name: "Services",
  components: {
    Navgar,
  },
  methods: {
    goContact() {
      console.log("-------");
      window.scrollTo({
        top: 2200,
        left: 0,
        behavior: "smooth",
      });
      // this.$router.push('/contact');
    },
  },
};
</script>

<style scoped>
.services {
  background: url("../assets/youzhi_background.png") no-repeat center center;
  background-size: cover;
  height: 85vh;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #333;
  text-align: center;
  padding-top: 15vh;
}

.content {
  display: flex;
  justify-content: space-around;
  width: 80%;
  margin: 0 10px;
}

.card {
  background: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 250px;
  border-radius: 30px 30px 30px 30px;
  border: 2px solid #c1c1c1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* 确保子元素之间的间距 */
}

.card-box1 {
  background: linear-gradient(180deg, #ffffff 54%, #ffe5e5 100%);
}

.card-box2 {
  background: linear-gradient(180deg, #ffffff 54%, #e5f6ff 100%);
}

.card h2 {
  font-size: 20px;
  margin-bottom: 10px;
}

.card ul {
  /* list-style: none; */
  padding: 0;
  text-align: left;
  flex-grow: 1;
  /* 确保 ul 元素占据剩余空间 */
}

.card ul li {
  margin-bottom: 10px;
  font-size: 12px;
}

.card button {
  background-color: #ff6f61;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 20px;
  cursor: pointer;
  width: 175px;
  margin: 10px auto;
}

.card button:hover {
  background-color: #ff5f50;
}

.arrow-container {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
}

.arrow-container img {
  width: 30px;
  height: auto;
}
</style>
